<template>
  <div class="good-project">
    <div class="title">用心打磨才是好项目</div>
    <div class="centent">
      <p>
        传智播客的每一套项目课程都要经过<span>8次</span>品控把关，从立项到研发，再到课程转化录制，
      </p>
      <p>
        每一个环节至少有<span>10项</span>的验收标准，制定如此复杂的流程和严格的标准，只为学员能够学到更优质的课程。
      </p>
    </div>
    <img src="../aiImg/route@2x.png" />
  </div>
</template>
<script>
export default {
  name: 'goodProject',
};
</script>
<style lang="scss" scoped>
.good-project {
  text-align: center;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #19232b;
    margin-top: 70px;
    margin-bottom: 20px;
  }
  .centent {
    line-height: 32px;
    color: #616a72;
    span {
      color: #006cff;
    }
  }
  img {
    height: 827px;
    width: 100%;
  }
}
</style>
